export interface Organization {
    id: string;
    name: string;
    users?: any;
    filteredUsers?: any;
}
